import React, { useState } from 'react';
import Layout from '../../components/layout'
import Head from 'next/head'
import Error from 'next/error'
import NextLink from 'next/link'
import Container from '../../components/Container';
import { 
    Box, 
    LinkBox, 
    Button, 
    Heading, Spinner, Center, Flex, Text, Link, UnorderedList, ListItem, 
    Tabs, TabList, Tab, TabPanels, TabPanel, LinkOverlay, Badge, Divider, Wrap, WrapItem, Stack, 
    HStack, VStack, useColorModeValue, Spacer, SimpleGrid, Container as ChakraContainer,
    StatGroup,
    Stat,
    StatLabel,
    StatNumber,
    StatHelpText,
    StatArrow,
 } from "@chakra-ui/react";
import prisma from '../../lib/prisma'
import { useUser, SignedIn } from "@clerk/nextjs";
import useSWR from "swr";

const fetcher = (url) =>
  fetch(url, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json'}),
    // credentials: 'same-origin',
  }).then((res) => res.json())

export default function Variant({errorCode, variant, summary}) {
    console.log(variant);
    const { user } = useUser()
    const [assembly, setAssembly] = useState('GRCh38')
    // console.log("VARIANT:");
    // console.log(variant);
    // console.log("SUMMARY:");
    // console.log(summary);

    function useUserGenotype() {
        const { data, error, isValidating } = useSWR(`/api/user/getGenotype?variantId=${variant ? variant.id: ''}`,fetcher, {dedupingInterval: 15000, revalidateOnFocus: false })
        // console.log(error);
        return {
          data: data,
          isLoading: !error && !data,
          isError: error
        }
      }

      const { data: userGT, isLoading: userGTLoading, isError: userGTError } = useUserGenotype()

    // useEffect(() => {
    //     if (user) {
    //         getUserGT(user.id, variant.rsid)
    //     }
    //   }, [user])

    // async function getUserGT(userID, rsid) {
    //     setGetUserGTLoading(true)
    //     try {
    //         let query = supabase
    //         .from('user_raw')
    //         .select("user_id, rsid, id, is_var, tgt, clinvar: clinvar!clinvar_id(clinical_significance, clin_sig_lvl)", { count: 'exact' })
    //         .eq('user_id', userID)
    //         .eq('rsid', 'rs' + rsid)
            
    
    //         const { data, error, count } = await query
            
    //         if (error) {
    //           throw error
    //         }

    //         setUserGT(data.length > 0 ? data[0].tgt : 'N/A')
    
    //     } catch (error) {
    //       console.log('Error getting data: ', error.message)
    //     }

    //     setGetUserGTLoading(false)
    // }

    if (!variant) {
        
            
        return (
            <Layout>
                <Container>
                    <Center>
            <h1>Sorry, variant not found!</h1>
            </Center>
            </Container>
            </Layout>
        )
    }

    if (errorCode) {
        return <Error statusCode={errorCode} />
    }
    const borderColor = useColorModeValue("gray.200", "neutral.900")
    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }

    const cardBg = useColorModeValue("gray.100", "neutral.1000")

    function cln_sig_color(param) {
        if (param[0].toUpperCase().includes('benign'.toUpperCase()) && param[0].toUpperCase().includes('pathogenic'.toUpperCase())) {
            return 'gray'
        }
        else if (param[0].toUpperCase().includes('benign'.toUpperCase())) {
            return 'green'
        }
        else if (param[0].toUpperCase().includes('pathogenic'.toUpperCase())) {
            return 'red'
        }
        else if (!param[0].toUpperCase().includes('benign'.toUpperCase()) && !param[0].toUpperCase().includes('pathogenic'.toUpperCase())) {
            return 'gray'
        }
    };

    return (
        <>
    <Layout>
    <Head>
        <title>rs{variant.rsid}</title>
      </Head>
    <Container>
        <ChakraContainer maxW={['6xl']} mb={100}>
        <Flex columns={3} mt={70}>
            <Box>
                <Stack>
                <Tabs variant='soft-rounded' colorScheme='teal' mb={5} id='assembly-tabs' isLazy defaultIndex={0}>
                    <TabList>
                    <Tab fontSize={13} onClick={() => setAssembly('GRCh38')}>GRCh38</Tab>
                        <Tab fontSize={13} onClick={() => setAssembly('GRCh37')}>GRCh37</Tab>
                    </TabList>
                    </Tabs>
                <Heading as="h1" fontSize="3xl">rs{variant.rsid}</Heading>
                <Wrap>
                {variant.clinvar.length > 0 ?
                variant.clinvar.map((clinvar, index) => clinvar.assembly == assembly && <WrapItem key={index}><Badge ml="0" mt="5" colorScheme={cln_sig_color(clinvar.clinical_significance)} borderRadius="lg" pl={2} pr={2} pt={2} pb={2} textTransform="capitalize">{clinvar.clinical_significance}</Badge></WrapItem> )
                
                : null 
                }
                </Wrap>
                </Stack>
            </Box>
            <Spacer />
            {user ? 
            <Box border={'1px'} borderRadius={10} p={5} borderColor={'gray.200'}>
                <Center>
                <VStack>
                <Heading size="md">Your Genotype</Heading>
                {userGTLoading ? <Spinner color="cyan.500" size="lg" thickness="3px"/> :
                userGT && userGT.results && userGT.results.length > 0 ?
                <Stack>
                <Badge p={3} borderRadius={100} fontSize={"16px"}>{userGT.results[0].tgt}</Badge>
                <Text fontSize="13">{userGT.results[0].assembly}</Text>
                </Stack>
                :
                <Text fontSize="13">You don't have this variant <br/>or not annotated</Text>
                }
                </VStack>
                </Center>
                
            </Box>
            : 
            <Box border={'1px'} borderRadius={10} p={5} borderColor={'gray.200'}>
                
            <Center>
            <VStack>
            <Heading size="md">Your Genotype</Heading>
            <Button
                as={'a'}
                fontSize={'sm'}
                fontWeight={600}
                variant={'link'}
                href={'/signin'}>
                Sign In
                </Button>
            
            </VStack>
            </Center>
            
        </Box>
        }
        </Flex>

        <Divider mb={10} mt={5}/>
        <Flex
            direction={['column-reverse', 'column-reverse', 'row', 'row']}
            w="full"
            justify="space-between"

        >

            <Box mt={[8, 8, 0]} mb={3} minW={['', 'xl']} maxW={['2xl', '2xl', '2lg', '2xl']}>

                
                <Heading as="h3" mb={3} fontSize="lg" fontWeight="bold">Description</Heading>
                {summary.map((submission, index) => <Text key={index}>{submission.description}</Text>)}
            </Box>

            <Flex flexDirection={["row", "row", "column", "column"]}>
            <Box border="1px" p={5} borderRadius={10} borderColor={borderColor} w={['45%', '%45', '100%']} minW={['', '2xs']}>
            <div>
                <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Reference Allele</Heading>
                {variant.variant_map.map((varmap, index) => varmap.assembly == assembly && <Text key={index}>{varmap.ref}</Text>)}
                <Divider my={3} />
                <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Alternative Allele</Heading>
                {variant.variant_map.map((varmap, index) => varmap.assembly == assembly && varmap.alt.map((alt, index) => <Text key={index}>{alt}</Text>))}
                </div>
            </Box>
            {/* <Spacer /> */}
            <Box border="1px" p={5} mt={['0', '0', '5']}borderRadius={10} borderColor={borderColor} minW="220px" w={['45%', '%45', '100%']}>
            <div>
                <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Chromosome</Heading>
                {variant.variant_map.map((varmap, index) => varmap.assembly == assembly && <Text key={index}>{varmap.chr}</Text>)}
                <Divider my={3}/>
                <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Location</Heading>
                {variant.variant_map.map((varmap, index) => varmap.assembly == assembly && <Text key={index}>{varmap.pos}</Text>)}
                <Divider my={3}/>
                </div>
            <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Variant Type</Heading>
                <Text fontSize="md">{variant.type}</Text>
            </Box>

            </Flex>
            </Flex>
            <Flex
            direction={['column-reverse', 'column-reverse', 'row', 'row']}
            w="full"
            justify="space-between"
            >
        <Box mt={[8, 8, 30]} mb={3} minW={['', 'xl']} maxW={'2xl'}>
        <Heading as="h3" mb={3} fontSize="lg" fontWeight="bold">Genes</Heading>
        <Wrap>
            {variant.genes.map((gene, index) => 
            <LinkBox as="div" key={index}>
            <WrapItem>
                        <Badge ml="0" colorScheme={gene.genes ? 'cyan' : 'gray'} borderRadius="lg" pl={2} pr={2} pt={2} pb={2} textTransform="capitalize">
                            {gene.genes ? 
                        <NextLink href={`/genes/${gene.genes.slug}`} passHref>
                            <LinkOverlay>
                                <Text>{gene.symbol}</Text>
                            </LinkOverlay>
                            </NextLink>
                            : 
                                <Text>{gene.symbol}</Text>
                             }
                        </Badge>
            </WrapItem>
            </LinkBox>
            )}
            
                </Wrap>
                </Box>
            </Flex>
            <Flex
            direction={['column-reverse', 'column-reverse', 'row', 'row']}
            w="full"
            justify="space-between"
            >
            <Box mt={[8, 8, 30]} mb={3} minW={['', 'xl']} maxW={'2xl'}>
        <Heading as="h3" mb={3} fontSize="lg" fontWeight="bold">Phenotypes</Heading>
        <Wrap>
            {variant.phenotypes.map((phenotype, index) => 
            
            <LinkBox as="div" key={index}>
            <WrapItem>
                        <Badge ml="0" colorScheme={phenotype.phenotypes ? 'cyan' : 'gray'} borderRadius="lg" pl={2} pr={2} pt={2} pb={2} textTransform="capitalize">
                        {phenotype.phenotypes ? 
                        <NextLink href={`/phenotypes/${phenotype.phenotypes.slug}`} passHref>
                            <LinkOverlay>
                                {phenotype.phenotypes.name}
                            </LinkOverlay>
                            </NextLink>
                            :
                            <Text>{phenotype.name}</Text>
                        }
                        </Badge>
            </WrapItem>
            </LinkBox>
            
            )}
                </Wrap>
                </Box>
                </Flex>
                <Flex
            direction={['column-reverse', 'column-reverse', 'row', 'row']}
            w="full"
            justify="space-between"
            mt={10}
            >
                
            <Box minW={['', 'xl']} maxW={['2xl', '2xl', '2lg', '2xl']}>
            <Heading as="h3" mb={3} fontSize="lg" fontWeight="bold">ClinVar</Heading>
            {variant.clinvar.length > 0 ?

            <Tabs id="clinvar-tabs">
            <TabList>
            {variant.clinvar.map((tab, index) => (
                tab.assembly == assembly &&
                <Tab key={index}>{tab.alt}</Tab>
            ))}
            </TabList>
            <TabPanels>
            {variant.clinvar.map((tab, index) => (
                tab.assembly == assembly && 
                <TabPanel key={index}>
                            <Box border="1px" p={5} borderRadius={10} borderColor={borderColor} w={['100%', '100%']}>
                <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Name</Heading>
                <Text fontSize="md">{tab.name}</Text>
                <Divider my={3} />
                <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Allele</Heading>
                <Text fontSize="md">{tab.alt}</Text>
                <Divider my={3} />
                <Heading as="h3" fontSize="10" color="gray.500" textTransform="uppercase">Clinical Significance</Heading>
                {tab.clinical_significance ? tab.clinical_significance.map((tab, index) => <Text fontSize="md" key={index}>{tab}</Text>): null}
            </Box>
                </TabPanel>
            ))}
            </TabPanels>
            </Tabs>
            : null }
            </Box>
            </Flex>
        </ChakraContainer>
        </Container>
    </Layout>
    </>
    )
}

export async function getServerSideProps(context) {
    if (!context.params.slug.startsWith('rs')) {
        return {
            notFound: true
        }
    }

    var queryArgs = {}
    queryArgs = {
        slug: context.params.slug
    }

    const clinvar = await prisma.clinvar.findMany({
        where: {
            rsid: parseInt(context.params.slug.replace('rs', ''))
        },
        select: {
            rsid: true,
            variation_id: true
        }
    })

    const variation_id = clinvar && clinvar.length > 0 ? clinvar[0].variation_id : undefined
  
    const [variant, summary] = await prisma.$transaction([
        prisma.variants.findUnique({
        where: queryArgs,
        select: {
            id: true,
            description: true,
            name: true,
            rsid: true,
            summary: true,
            type: true,
            variant_map: {
                select: {
                    chr: true,
                    pos: true,
                    assembly: true,
                    ref: true,
                    alt: true
                }
            },
            clinvar: {
                select : {
                    name: true,
                    assembly: true,
                    alt: true,
                    clinical_significance: true
                }
            },
            genes: {
                select: {
                    symbol: true,
                    genes: {
                    select: {
                        slug: true
                        }
                    }
                }
            },
            phenotypes: {
                select: {
                    name: true,
                    phenotypes: {
                        select: {
                            name: true,
                            slug: true
                        }
                    }
                }
            }
        },
      }),
      prisma.clinvar_submission.findMany({
        where: {
            variation_id: variation_id ? variation_id : -1000000000000000
        },
        select: {
            description: true,
            variation_id: true
        }
    })
    ])
    
    if (!variant) {
            return {
                notFound: true
            }
    }
  
    const variant_data = JSON.stringify(variant, (key, value) => (typeof value === 'bigint' ? value.toString() : value))
    const summary_data = JSON.stringify(summary, (key, value) => (typeof value === 'bigint' ? value.toString() : value))
  
    return { props: { variant: JSON.parse(variant_data), summary: JSON.parse(summary_data) } }
    }